import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'
import { FormInput } from '@myxplor/forms'
import { ShowHide } from '../../../../ui/record-display'
import GovSiteImage from './gov-site-device-rego.svg'

export const DeviceRegistrationFields = ({ onChange, values = {} }) => (
  <Fragment>
    <Heading small>B2B Device Registration</Heading>
    <p>
      The information required for the below can be obtained through{' '}
      <a href="https://proda.humanservices.gov.au/prodalogin/pages/public/login.jsf">PRODA</a>{' '}
      <i>(the government website)</i>.<br />
      Need help finding the ID numbers?{' '}
      <a
        href="https://support.myxplor.com/hc/en-us/articles/360001215267?ref=rebates"
        rel="noopener noreferrer"
        target="_blank">
        View our Knowledge Base Article
      </a>
    </p>

    <ShowHide label="help with government numbers">
      <img
        alt="Sample representation of the government website"
        className="screenshot"
        src={GovSiteImage}
      />
    </ShowHide>

    <fieldset>
      <FormInput
        name="device_name"
        label="Unique/Device Name"
        hint="This is the name you entered for the device on the government site. It can not contain spaces"
        value={values.device_name}
        required
        onChange={onChange}
        autoFocus
      />

      <FormInput
        name="one_time_access_token"
        label="CCS Activation Code/Device Activation Code"
        hint="The Activation Code is was provided to you on the government site. It is 10 digits long, and contains numbers and letters"
        maxLength={10}
        value={values.one_time_access_token}
        required
        onChange={onChange}
      />
    </fieldset>
  </Fragment>
)



// WEBPACK FOOTER //
// ./src/providers-registrations/onboarding/device-registration/views/fields.jsx